export default function IconAutoplay() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6 10.3004C6 10.9238 6.4563 11.178 7.01912 10.8677L11.2028 8.56176C11.7658 8.25143 11.7658 7.74854 11.2028 7.43815L7.01912 5.13216C6.4563 4.82217 6 5.07603 6 5.70004L6 10.3004Z"
        fill="white" />
    </svg>
  );
}
